// extracted by mini-css-extract-plugin
export default {"bg":"Er4NNm","inlineContent":"iugd_I","pageWrapper":"wuQWjL","innerBg":"UyFu_5"};